import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { fromEvent, merge, Observable, Subscription, timer } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class IdleService {
  private idleSubscription: Subscription;
  private timeoutDuration = 48 * 60 * 60 * 1000; // 48 horas

  constructor(
    private authService: AuthService,
    private router: Router,
    private ngZone: NgZone
  ) {}

  startWatching() {
    this.stopWatching();

    this.ngZone.runOutsideAngular(() => {
      const activityEvents$ = merge(
        fromEvent(window, 'mousemove'),
        fromEvent(window, 'mousedown'),
        fromEvent(window, 'keypress'),
        fromEvent(window, 'scroll'),
        fromEvent(window, 'touchstart')
      );

      this.idleSubscription = activityEvents$
        .pipe(switchMap(() => timer(this.timeoutDuration)))
        .subscribe(() => {
          this.ngZone.run(() => {
            if (this.authService.isLoggedIn()) {
              this.logout();
            }
          });
        });

      timer(this.timeoutDuration).subscribe(() => {
        this.ngZone.run(() => {
          if (this.authService.isLoggedIn()) {
            this.logout();
          }
        });
      });
    });
  }

  stopWatching() {
    if (this.idleSubscription) {
      this.idleSubscription.unsubscribe();
    }
  }

  private logout() {
    this.authService.logout();
    this.router.navigate(['/']);
  }
}
